import { Component, OnInit, Output, EventEmitter } from '@angular/core';

import { GoogleAdsenseComponent } from '../google-adsense/google-adsense.component';

import { Color } from '../color';
import { Font } from '../font';

@Component({
  selector: 'app-control',
  templateUrl: './control.component.html',
  styleUrls: ['./control.component.css'],
  standalone: false
})
export class ControlComponent implements OnInit {
  private _title = 'TeXCrop';
  get title() {
    return this._title;
  }
  private _version = "0.6.0";
  get version() {
    return this._version;
  }

  private palette_rows = 8;
  private palette_cols = 10;
  
  private _color_palette = [
    [[1,1,1],       [1,0.8,0.8], [1,0.8,0.6], [1,1,0.6],     [1,1,0.8],   [0.6,1,0.6], [0.6,1,1],     [0.8,1,1],   [0.8,0.8,1],   [1,0.8,1]],
    [[0.8,0.8,0.8], [1,0.4,0.4], [1,0.6,0.4], [1,1,0.4],     [1,1,0.2],   [0.4,1,0.6], [0.2,1,1],     [0.4,1,1],   [0.6,0.6,1],   [1,0.6,1]],
    [[0.6,0.6,0.6], [1,0,0],     [1,0.6,0],   [1,0.8,0.4],   [1,1,0],     [0.2,1,0.2], [0.4,0.8,0.8], [0.2,0.8,1], [0.4,0.4,0.8], [0.8,0.4,0.8]],
    [[0.4,0.4,0.4], [0.8,0,0],   [1,0.4,0],   [1,0.8,0.2],   [1,0.8,0],   [0.2,0.8,0], [0,0.8,0.8],   [0.2,0.4,1], [0.4,0.2,1],   [0.8,0.2,0.8]],
    [[0.2,0.2,0.2], [0.6,0,0],   [0.8,0.4,0], [0.8,0.6,0.2], [0.6,0.6,0], [0,0.6,0],   [0.2,0.6,0.6], [0.2,0.2,1], [0.4,0,0.8],   [0.6,0.2,0.6]],
    [[0.1,0.1,0.1], [0.4,0,0],   [0.6,0.2,0], [0.6,0.4,0.2], [0.4,0.4,0], [0,0.4,0],   [0.2,0.4,0.4], [0,0,0.6],   [0.2,0.2,0.6], [0.4,0.2,0.4]],
    [[0,0,0],       [0.2,0,0],   [0.4,0.2,0], [0.4,0.2,0.2], [0.2,0.2,0], [0,0.2,0],   [0,0.2,0.2],   [0,0,0.4],   [0.2,0,0.6],   [0.2,0,0.2]]
  ];
  get color_palette() {
    return this._color_palette;
  }

  private _resolutionOptions: number[] = [ 150, 300, 600, 1200 ];
  get resolutionOptions(): number[] {
    return this._resolutionOptions;
  }
  
  private _resolution = 300;
  set resolution(value: number) {
    this._resolution = value;
  }
  get resolution() {
    return this._resolution;
  }

  private _fontOptions: Font[] = [];
  set fontOptions(fonts: Font[]) {
    this._fontOptions = fonts;
  }
  get fontOptions() {
    return this._fontOptions;
  }
  
  private _font = "cm";
  set font(value: string) {
    this._font = value;
  }
  get font() {
    return this._font;
  }

  private _jfontOptions: Font[] = [];
  set jfontOptions(fonts: Font[]) {
    this._jfontOptions = fonts;
  }
  get jfontOptions() {
    return this._jfontOptions;
  }

  _jfont = "haranoaji";
  set jfont(value: string) {
    this._jfont = value;
  }
  get jfont() {
    return this._jfont;
  }

  private _bold = false;
  set bold(value: boolean) {
    this._bold = value;
  }
  get bold() {
    return this._bold;
  }
  
  private _opaque = false;
  set opaque(value: boolean) {
    this._opaque = value;
  }
  get opaque() {
    return this._opaque;
  }
  
  constructor() {
  }

  ngOnInit(): void {
  }

  @Output()colorSelected = new EventEmitter<Color>();

  onColorPaletteClick(r, c): void {
    const rgb = this.color_palette[r][c];
    this.colorSelected.emit(new Color({ r: rgb[0], g: rgb[1], b: rgb[2] }));
  }

  colorPaletteStyle(r, c): string {
    let rgb = this.color_palette[r][c];
    rgb = rgb.map(x => Math.round(x * 255));
    return "background-color:rgb(" + rgb[0] + "," + rgb[1] + "," + rgb[2] + ");";
  }

  colorPaletteClass(r, c): string {
    const rgb = this.color_palette[r][c];
    const brightness = rgb[0] * 0.299 + rgb[1] * 0.587 + rgb[2] * 0.114;
    return (brightness > 0.5) ? "light" : "dark";
  }

  @Output()generateClicked = new EventEmitter();
  
  onGenerateClick(): void {
    this.generateClicked.emit();
  }

  @Output()downloadClicked = new EventEmitter<string>();

  onDownloadClick(fileType: string): void {
    this.downloadClicked.emit(fileType);
  }

  @Output()resetClicked = new EventEmitter();

  onResetClicked(): void {
    console.log("reset clicked");
    this.resetClicked.emit();
  }
}
